import { useEffect, useState } from "react"
import { useApp } from "../../../hooks/AppProvider"
import { DaySelectCell, EditDeleteCell, InputCell, Table, NewRowTemplate } from "../../../components/BasicComponents";

import '../../../css/game-config.css'


function GameConfigTable({ calculations, overlapId, onModify, onDelete, onAdd }) {    
    return (
        <>
            <Table headers={["Jour de calcul", "Heure de calcul", "Jour de remise à zéro", "Heure de remise à zéro", ""]}>
                {calculations.map(data => (
                    <GameConfigRow
                        key={data.id}
                        id={data.id}
                        isOverlap={overlapId === data.id}
                        calcDay={data.calc[0]}
                        calcHour={data.calc[1]}
                        calcMinute={data.calc[2]}
                        relDay={data.release[0]}
                        relHour={data.release[1]}
                        relMinute={data.release[2]}
                        onModify={onModify}
                        onDelete={onDelete}
                    />
                ))}
                <NewRow onAdd={onAdd} />
            </Table>
        </>
    )
}

function GameConfigRow({ id, isOverlap, calcDay, calcHour, calcMinute, relDay, relHour, relMinute, onModify, onDelete }) {
    if(calcHour < 10) calcHour = "0" + calcHour;

    if(calcMinute < 10) calcMinute = "0" + calcMinute;

    if(relHour < 10) relHour = "0" + relHour;

    if(relMinute < 10) relMinute = "0" + relMinute;

    let [change, setChange] = useState(false);

    let [calcDay0, setCalcDay0] = useState(calcDay);
    let [calcTime, setCalcTime] = useState(calcHour + ":" + calcMinute);
    let [relDay0, setRelDay0] = useState(relDay);
    let [relTime, setRelTime] = useState(relHour + ":" + relMinute);

    function submitChange() {
        if(calcTime == "")
            return alert("L'heure de calcul est vide");

        if(relTime == "")
            return alert("L'heure de remise à zéro est vide");

        onModify(id, calcDay0, calcTime, relDay0, relTime);
        setChange(false);
    }
        
    function del() {
        if(window.confirm("Vous êtes sur le point de supprimer un horaire de calcul. Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    }

    return (
        <>
        <tr key={id} className={isOverlap ? "error-row" : ""}>
            <DaySelectCell value={calcDay0} onChange={e => {setCalcDay0(e.target.value); setChange(true);}} />
            <InputCell
                type="time"
                value={calcTime}
                onChange={e => {setCalcTime(e.target.value); setChange(true);}}
            />
            <DaySelectCell value={relDay0} onChange={e => {setRelDay0(e.target.value); setChange(true);}} />
            <InputCell
                type="time"
                value={relTime}
                onChange={e => {setRelTime(e.target.value); setChange(true);}}
            />
            <EditDeleteCell onDelete={del} onEdit={submitChange} change={change} />
        </tr>
        </>
    );
}

function NewRow({ onAdd }) {
    let [newCalcDay, setNewCalcDay] = useState("");
    let [newCalcTime, setNewCalcTime] = useState("");
    let [newRelDay, setNewRelDay] = useState("");
    let [newRelTime, setNewRelTime] = useState("");

    function add() {

        onAdd(newCalcDay, newCalcTime, newRelDay, newRelTime, (data) => {
            setNewCalcDay(0);
            setNewCalcTime("");
            setNewRelDay(0);
            setNewRelTime("");
        });
    }

    return (
       <NewRowTemplate>
            <DaySelectCell value={newCalcDay} onChange={e => setNewCalcDay(e.target.value)} />
            <InputCell type="time" value={newCalcTime} onChange={e => setNewCalcTime(e.target.value)} />
            <DaySelectCell value={newRelDay} onChange={e => setNewRelDay(e.target.value)} />
            <InputCell type="time" value={newRelTime} onChange={e => setNewRelTime(e.target.value)} />
            <td>
                <button className="button-add" onClick={add}>Ajouter</button>
            </td>
        </NewRowTemplate>
    );
}

function GameConfig() {

    let app = useApp();
    let [calculations, setCalculations] = useState([]);
    let [update, setUpdate] = useState(0);

    let [overlapId, setOverlapId] = useState(-1);

    useEffect(() => {
        app.sendGet("/game/calculations", data => {
            setCalculations(data);
        });
    }, [update])
    

    function onModify(id, calcDay, calcTime, relDay, relTime) {
        let [calcH, calcM] = calcTime.split(":");
        let [relH, relM] = relTime.split(":");

        app.sendPost("/game/calculations/update", {id: id, calc: [calcDay, calcH, calcM], rel: [relDay, relH, relM]}, data => {
            if(data.success === false) {
                if(data.overlapId) {
                    setOverlapId(data.overlapId);
                }else {
                    alert("Error: " + data.message);
                }
                return;
            }
            setUpdate(update + 1);
            setOverlapId(-1);
        })
    }

    function onAdd(calcDay, calcTime, relDay, relTime, callback = (data) => {}) {
        if(calcTime == "")
            return alert("La nouvelle heure de calcul est vide.");

        if(relTime == "")
            return alert("La nouvelle heure de remise à zéro est vide.");

        if(calcDay == "") {
            return alert("Le nouveau jour de calcul est vide.");
        }

        if(relDay == "") {
            return alert("Le nouveau jour de remise à zéro est vide.");
        }

        let [calcH, calcM] = calcTime.split(":");
        let [relH, relM] = relTime.split(":");


        app.sendPost("/game/calculations/add", {calc: [calcDay, calcH, calcM], rel: [relDay, relH, relM]}, data => {
            if(data.success === false) {
                if(data.overlapId) {
                    setOverlapId(data.overlapId);
                }else {
                    alert("Error: " + data.message);
                }
                return;
            }
            setOverlapId(-1);
            setCalculations([... calculations, data]);

            callback(data);
        })   
    }

   function onDelete(id) {
        app.sendPost("/game/calculations/delete", {id: id}, data => {
            if(data.success === false) {
                if(data.overlapId) {
                    setOverlapId(data.overlapId);
                }else {
                    alert("Error: " + data.message);
                }
                return;
            }
            setUpdate(update + 1);
            setOverlapId(-1);

        });
    }
    
    return (
        <>
            <GameConfigTable  calculations={calculations} overlapId={overlapId} onModify={onModify} onDelete={onDelete} onAdd={onAdd} />
            <span className="error-text">
                {overlapId !== -1 ? "Un horaire de calcul est en conflit avec un autre. Les modifications n'ont pas été appliquées." : ""}
            </span>
        </>
    )
}

export default GameConfig;